import { apiRequest } from '@/shared/api/client';

/* Admin Web Push subscription registration. The backend stores the browser's
   push endpoint + keys and fans out encrypted notifications to it (chat,
   problem orders, refill requests). */

export interface PushSubscriptionPayload {
  endpoint: string;
  p256dh: string;
  auth: string;
}

export interface PushConfig {
  /** Backend VAPID public key the browser must subscribe with. `null` when
      Web Push is disabled server-side. */
  vapid_public_key: string | null;
  enabled: boolean;
}

export const notificationsApi = {
  /* The backend is the single source of truth for the VAPID public key — the
     browser subscribes with the exact key the backend signs with, so there is
     no silent 403 mismatch and no dependence on a build-time inlined key. */
  config: (): Promise<PushConfig> => apiRequest<PushConfig>('/v1/admin/push/config'),

  subscribe: (payload: PushSubscriptionPayload): Promise<{ subscribed: boolean }> =>
    apiRequest<{ subscribed: boolean }>('/v1/admin/push/subscribe', {
      method: 'POST',
      json: payload,
    }),

  unsubscribe: (endpoint: string): Promise<void> =>
    apiRequest<void>('/v1/admin/push/subscribe', {
      method: 'DELETE',
      json: { endpoint },
    }),
};
